import React from 'react';
import Helmet from 'react-helmet';
import { useSelector } from 'react-redux';

import Immutable from 'immutable';
import { CoreLink } from '@uncinc/react-drupal-core';
import { Container, Accordion, AccordionItem, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { DEFAULT_LANGUAGE } from '../../../config/constants';
import './style.scss';

const Accordeon = ({ id, entity, wide = false }) => {
  const title = entity.getIn(['field_title', 0, 'value'], null);
  const body = entity.getIn(['field_body', 0, 'processed'], null);
  const openFirstItem = entity.getIn(['field_open_first_item', 0, 'value'], false);

  const faqItems = entity.toJS();

  const currentEntityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const currentEntity = useSelector((state) => state.getIn(['node', currentEntityId], Immutable.Map()));
  const langcode = currentEntity.getIn(['langcode', 0, 'value'], DEFAULT_LANGUAGE);
  const path = currentEntity.getIn(['paths', langcode], '/');

  const schema = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    '@id': path,
    mainEntity: faqItems.field_paragraphs.map((faqItem) => ({
      '@type': 'Question',
      name: faqItem.entity.field_title[0].value,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faqItem.entity.field_body[0].processed,
      },
    })),
  });

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {schema}
        </script>
      </Helmet>

      <Container>
        <div id={id} className="row Paragraph ParagraphAccordeon">
          <div className={`ParagraphAccordeon__inner ${wide ? 'col-12 wide' : 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2'}`}>
            <div className={wide ? 'row' : 'ParagraphAccordeon__wrapper'}>
              <div className={wide && 'col-12 col-md-5 col-lg-4'}>
                {title && (
                  <div className="ParagraphAccordeon__title">
                    <h3>{title}</h3>
                  </div>
                )}
                {body && (
                  <div className="ParagraphAccordeon__body">
                    <WysiwygField
                      property="schema:text"
                      html={body}
                    />
                  </div>
                )}
              </div>
              <div className={wide && 'col-12 col-md-7 col-lg-8'}>
                <Accordion>
                  {entity.getIn(['field_paragraphs'], Immutable.List()).map((item, index) => {
                    const accordeonEntity = item.get('entity');
                    return (
                      <AccordionItem
                        defaultValue={!(openFirstItem && index === 0)}
                        entity={accordeonEntity}
                        key={item.get('target_uuid')}
                        iconClassName="icon-chevron-right"
                        title={accordeonEntity.getIn(['field_title', 0, 'value'])}
                        content={(
                          <div>
                            <WysiwygField html={accordeonEntity.getIn(['field_body', 0, 'processed'], '')} />
                            {accordeonEntity.getIn(['field_link', 0]) && (
                              <div className="Accordion__item__content__link">
                                <CoreLink to={accordeonEntity.getIn(['field_link', 0, 'alias'], accordeonEntity.getIn(['field_link', 0, 'uri']))}>
                                  {accordeonEntity.getIn(['field_link', 0, 'title'])}<i className="icon icon-before icon-arrow-right icon-variant-2" />
                                </CoreLink>
                              </div>
                            )}
                          </div>
                        )}
                        titleComponent={({ className, children }) => {
                          return (<h4 className={className}>{children}</h4>);
                        }}
                      />
                    );
                  })}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Accordeon;
